<div class="backDrop" *ngIf="showSubject.asObservable() | async">
    <div class="modal-dialog modal-lg update-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ linkInformation.displayName }} : {{linkInformation.shortDescription}}</h4>
            </div>

            <al-tabs [tabInfo]="tabInfo" [selectedTab$]="selectedTab$"></al-tabs>

            @if(selectedTab$ | async; as tabIndex) {
                <div class="modal-body">

                    <div style="padding-top:7px;" class="tabs-container">
                        <al-link-edit-information [linkInfo]="linkInformation" *ngIf="tabIndex === 1"></al-link-edit-information>
                        <al-link-edit-pricing [linkInfo]="linkInformation" *ngIf="tabIndex === 2"></al-link-edit-pricing>
                    </div>
                </div>
                <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="cancel()">
                        Cancel
                    </button>
                </div> -->
                <div>
                    <hr style="margin-top: 0px">
                </div>
                <div class="agreement-container" *ngIf="tabIndex === 2">
                    <div style="padding-left:10px;" class="agreement-text">
                        I agree to the terms and conditions: <dx-check-box class="al-checkbox-big" [(value)]="userAccepted"></dx-check-box>
                    </div>
                    <button  (click)="addApplication()" [disabled]="!userAccepted" [ngStyle]="{'background-color': userAccepted ? 'orange' : 'grey'}" style="scale: 1.25;" type="button" class="btn btn-sm btn-secondary">
                        Activate
                    </button>
                </div>
                <div style="padding: 10px">
                    <button style="float:right; width: 70px; height: 35px;" type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="cancel()">
                        Cancel
                    </button>
                </div>
            }
        </div>
    </div>
</div>
